import Circle from './circle';
import Bar from './bar';

const Progress = {
  Circle,
  Bar,
};

export default Progress;
export type * from './types';
